module.exports = __webpack_public_path__ + "img/3-6-1.9fefe030.png";